/**
 * General number formatter
 *
 * Configurable using the i18n module
 * configuration key: formatter.number
 * configuration values: {
 *   decimal: The separator of the decimal part of the float number,
 *   thousand: The separator of the thousand blocks of the integer part of the number
 * }
 */

import i18n from '../../../../shared/modules/i18n';

var localizedTexts = i18n({$markup: undefined, keyPrefix: 'formatter.number'}),
    defaultDecimalSeparator = '.', // Keep the same separator as the JS float
    notNumberRegex = /[^\d]/g;

function getSeparators() {
    return {
        decimal: localizedTexts.get('decimal') || defaultDecimalSeparator,
        thousand: localizedTexts.get('thousand') || ','
    };
}

function cleanupValue(value) {
    var separators = getSeparators(),
        lastDecimalSeparatorPosition = Math.max(
            value.lastIndexOf(separators.decimal),
            value.lastIndexOf(defaultDecimalSeparator)
        ),
        values = {};

    if (lastDecimalSeparatorPosition === -1) {
        values.integer = value.replace(notNumberRegex, '');
        values.fraction = '';
        values.separator = '';
    } else {
        values.integer = value.substring(0, lastDecimalSeparatorPosition).replace(notNumberRegex, '');
        values.fraction = value.substring(lastDecimalSeparatorPosition + 1). replace(notNumberRegex, '');
        values.separator = values.fraction.length > 0 ? separators.decimal : '';
    }
    return values;
}

function fillIntegerWithThousandSeparators(integerValue) {
    var separators = getSeparators(),
        thousandPosition = integerValue.length % 3,
        formattedIntegerValue = integerValue.substring(0, thousandPosition);

    for(; thousandPosition <= integerValue.length; thousandPosition += 3) {
        if (thousandPosition !== 0 && thousandPosition !== integerValue.length) {
            formattedIntegerValue = formattedIntegerValue + separators.thousand;
        }
        formattedIntegerValue += integerValue.substring(thousandPosition, thousandPosition + 3);
    }

    return formattedIntegerValue;
}

export default function format(value) {
    var numberString = (value || '').toString(),
        values = cleanupValue(numberString);

    return {
        formatted: fillIntegerWithThousandSeparators(values.integer) + values.separator + values.fraction,
        raw: values.integer + (values.fraction.length > 0 ? defaultDecimalSeparator : '') + values.fraction,
        hint: ''
    };
}


//////////////////
// WEBPACK FOOTER
// ./widgets/Common/js/formatter/numberFormatter.js
// module id = 28
// module chunks = main